import {
  CREATE_PREPAYMENT_TRANSFER_REQUEST,
  CREATE_PREPAYMENT_TRANSFER_SUCCESS,
  CREATE_PREPAYMENT_TRANSFER_FAIL,
  PREPAYMENT_TRANSFER_REQUEST,
  PREPAYMENT_TRANSFER_SUCCESS,
  PREPAYMENT_TRANSFER_FAIL,
  FIND_PREPAYMENT_TRANSFER_REQUEST,
  FIND_PREPAYMENT_TRANSFER_SUCCESS,
  FIND_PREPAYMENT_TRANSFER_FAIL,
  UPDATE_PREPAYMENT_TRANSFER_REQUEST,
  UPDATE_PREPAYMENT_TRANSFER_SUCCESS,
  UPDATE_PREPAYMENT_TRANSFER_FAIL,
  CLEAR_PREPAYMENT_TRANSFER_ERROR,
} from "../../constants_Phase_2/PrepaymentTransfer/PrepaymentTransferConstant";

// create
export const prepaymentTransferReducer = (state = { prepaymentTransferList: [] }, action) => {
  switch (action.type) {
    case PREPAYMENT_TRANSFER_REQUEST:
      return {
        ...state,
        loading: true,
        message: null,
        prepaymentTransferList: [],
        status: null,
        error: null,
      };

    case CREATE_PREPAYMENT_TRANSFER_REQUEST:
    case UPDATE_PREPAYMENT_TRANSFER_REQUEST:
      return {
        ...state,
        loading: true,
        message: null,
        status: null,
        error: null,
      };

    case PREPAYMENT_TRANSFER_SUCCESS:
      return {
        ...state,
        loading: false,
        prepaymentTransferList: action.payload,
        totalData: action.totalData || 0,
        currentPage: action.currentPage,
        message: action.message,
        status: action.status,
      };

    case CREATE_PREPAYMENT_TRANSFER_SUCCESS:
    case UPDATE_PREPAYMENT_TRANSFER_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.message,
        status: action.status,
      };

    case PREPAYMENT_TRANSFER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_PREPAYMENT_TRANSFER_FAIL:
    case UPDATE_PREPAYMENT_TRANSFER_FAIL:
      return {
        ...state,
        loading: false,
        prepaymentTransferList: [...state.prepaymentTransferList],
        message: action.message,
        status: action.status,
      };

    case CLEAR_PREPAYMENT_TRANSFER_ERROR:
      return {
        ...state,
        error: null,
        status: null,
        message: null,
      };

    default:
      return state;
  }
};

// find one
export const findPrepaymentTransferReducer = (state = { prepaymentTransfer: {} }, action) => {
  switch (action.type) {
    case FIND_PREPAYMENT_TRANSFER_REQUEST:
      return {
        prepaymentTransfer: {},
        loading: true,
      };

    case FIND_PREPAYMENT_TRANSFER_SUCCESS:
      return {
        ...state,
        loading: false,
        prepaymentTransfer: action.payload,
      };

    case FIND_PREPAYMENT_TRANSFER_FAIL:
      return {
        ...state,
        loading: false,
        prepaymentTransfer: {},
        error: action.payload
      };

    case "EMPTY_PREPAYMENT_TRANSFER":
      return {
        ...state,
        prepaymentTransfer: {}
      }

    case CLEAR_PREPAYMENT_TRANSFER_ERROR:
      return {
        ...state,
        error: null,
        status: null,
      };

    default:
      return state;
  }
};